<nz-modal [(nzVisible)]="isVisible" [nzOkLoading]="isBtnLoading">
  <ng-container *nzModalContent>
    <div class="groups-model-header w-100">
      <label class="modal-title"
      [translatable]="{
        transKey: 'shared.resetPasswordModal.title',
        modEnum: translationModulesEnum.shared
      }">
        {{ "shared.resetPasswordModal.title" | translate }}
      </label>
    </div>

    <div class="groups-model-content">
      <div class="new-model-dialog-body">
        <form [formGroup]="form">
          <!-- New Password -->
          <div class="form-group col-12">
            <label
              class="rp-label"
              [translatable]="{
                transKey: 'shared.resetPasswordModal.newPasswordLabel',
                modEnum: translationModulesEnum.shared
              }"
            >
              {{ "shared.resetPasswordModal.newPasswordLabel" | translate }}
            </label>
            <div class="rp-input-wrapper">
              <input
                formControlName="newPassword"
                [type]="isNewPasswordDisplayed ? 'text' : 'password'"
                class="rp-input"

              />
              <img
                class="rp-toggle-visibility"
                src="assets/icons/visible.svg"
                alt="show"
                *ngIf="!isNewPasswordDisplayed"
                (click)="toggleNewPassword()"
              />
              <img
                class="rp-toggle-visibility"
                src="assets/icons/invisible.svg"
                alt="hide"
                *ngIf="isNewPasswordDisplayed"
                (click)="toggleNewPassword()"
              />
            </div>
            <small
              class="rp-error"
              *ngIf="
                form.controls['newPassword'].invalid &&
                form.controls['newPassword'].touched
              "
              [translatable]="{
                transKey: 'shared.validations.minlength',
                modEnum: translationModulesEnum.shared
              }"
            >
              {{ "shared.validations.minlength" | translate }} 8
            </small>
          </div>

          <!-- Confirm Password -->
          <div class="form-group col-12">
            <label
              class="rp-label"
              [translatable]="{
                transKey: 'shared.resetPasswordModal.confirmPasswordLabel',
                modEnum: translationModulesEnum.shared
              }"
            >
              {{ "shared.resetPasswordModal.confirmPasswordLabel" | translate }}
            </label>
            <div class="rp-input-wrapper">
              <input
                formControlName="confirmPassword"
                [type]="isConfirmPasswordDisplayed ? 'text' : 'password'"
                class="rp-input"
               
              />
              <img
                class="rp-toggle-visibility"
                src="assets/icons/visible.svg"
                alt="show"
                *ngIf="!isConfirmPasswordDisplayed"
                (click)="toggleConfirmPassword()"
              />
              <img
                class="rp-toggle-visibility"
                src="assets/icons/invisible.svg"
                alt="hide"
                *ngIf="isConfirmPasswordDisplayed"
                (click)="toggleConfirmPassword()"
              />
            </div>
            <small
              class="rp-error"
              *ngIf="
                form.controls['confirmPassword'].errors?.mismatch &&
                form.controls['confirmPassword'].touched
              "
              [translatable]="{
                transKey: 'shared.resetPasswordModal.passwordMismatch',
                modEnum: translationModulesEnum.shared
              }"
            >
              {{ "shared.resetPasswordModal.passwordMismatch" | translate }}
            </small>
          </div>
        </form>
      </div>

      <div class="new-model-dialog-footer">
        <button
          class="btn btn-dark w-100"
          (click)="close()"
          [translatable]="{
            transKey: 'shared.resetPasswordModal.discard',
            modEnum: translationModulesEnum.shared
          }"
        >
          {{ "shared.resetPasswordModal.discard" | translate }}
        </button>
        <button
          class="btn btn-green w-100"
          [disabled]="form.invalid || isBtnLoading"
          (click)="onSubmit()"
          [translatable]="{
            transKey: 'shared.resetPasswordModal.save',
            modEnum: translationModulesEnum.shared
          }"
        >
          <i class="bx bx-loader-alt bx-spin ml-1" *ngIf="isBtnLoading"></i>
          {{ "shared.resetPasswordModal.save" | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>
